import { render, staticRenderFns } from "./HgFarmerInfoModal.vue?vue&type=template&id=31893afa&scoped=true"
import script from "./HgFarmerInfoModal.vue?vue&type=script&lang=js"
export * from "./HgFarmerInfoModal.vue?vue&type=script&lang=js"
import style0 from "./HgFarmerInfoModal.vue?vue&type=style&index=0&id=31893afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31893afa",
  null
  
)

export default component.exports